import { CLOSE_ALERT, OPEN_ALERT } from "../actionTypes";

export const openAlert = () => {
  return (dispatch) => {
    dispatch({ type: OPEN_ALERT });
  };
};

export const closeAlert = () => {
  return (dispatch) => {
    dispatch({ type: CLOSE_ALERT });
  };
};

